import React from 'react'
import { isMobile } from 'react-device-detect'
import { OrdersContext } from 'contexts/OrdersContext'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcSwitch,
  PixelAlert,
  PixelDate,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  PixelTag,
  SectionActions,
} from 'pixel-base'
import styled from 'styled-components'
import { COURIER_COMPANIES, get } from 'utils/api-routes.util'

interface ActiveDispatch {
  courier_id: string
  courier_name: string
  created_at: string
  dispatch_id: string
  dispatch_name: string
  warehouse_id: number | null
  warehouse_name: string
}
export interface IRider {
  rider_id: string
  rider_name: string
  prefix: string
}

export interface ICourier {
  courier_id: string | null
  courier_name: string | null
  courier_type: string
  courier_type_id: string
  courier_cos_centre: string | null
  courier_origin_city: string
  courier_company: string
  company_id: string | null
  image_path: string
  payment_gateway_id: string
  payment_gateway_name: string
  riders?: IRider[]
  order_type?: string
}

interface IOrder {
  shipping: {
    first_name: string
    last_name: string
    city: string
    phone: string
  }
  meta: {
    order_source: string
  }
  courier: {
    courier_name: string
    tracking_id: string
  }
  status: string
  number: number
  source_order_id: number
  store_order_id: number
  split_source_order_id: number | null
  date_created: string
  weight: number
  total: number
  customer_id: number
  store_id: number
  is_returning: boolean
  is_refuser: boolean
  is_duplicate: boolean
  is_split_child: boolean
  is_split_main: boolean
  split_child_ids: string
  split_main_id: string
  status_classification_id: number
  last_comment: string
  wa_is_read_flag: number
  is_customer_note: number
  exchanged_from_order_id: number | null
  customer_notes: string
  is_editable: boolean
  tracking_number?: string
  cod_amount?: number
}

interface ICreateConsignment extends IOrder {
  cod_amount: number
  tracking_number: string
}

interface IProps {
  selectedOrders: IOrder[]
  onCreateConsignment: (obj: any) => void
  isMustDispatch: boolean
  handleClose: () => void
}
const OrdersCreateBulkConsignments = (props: IProps) => {
  const { showFailure, hidePageLoader, showPageLoader } = React.useContext(
    PixelFactoryContext,
  ) as any
  const { selectedOrders, onCreateConsignment, isMustDispatch } = props
  const [data, setData] = React.useState<IOrder[]>(selectedOrders)
  const [selectedCompany, setSelectedCompany] = React.useState<ICourier>({
    courier_id: null,
    courier_name: null,
    courier_type: '',
    courier_type_id: '',
    courier_cos_centre: null,
    courier_origin_city: '',
    courier_company: '',
    company_id: null,
    image_path: '',
    payment_gateway_id: '',
    payment_gateway_name: '',
  })
  const [CNSetting, setCNSetting] = React.useState({
    serviceType: false,
    serviceTypeRider: false,
    isCreatedDispatch: false,
    isManualConsignment: false,
    courierServiceType: false,
    shipmentType: '',
  })
  const { state } = React.useContext(OrdersContext)
  const [riderList, setRiderList] = React.useState<IRider[]>([])
  const [warehouseList, setWarehouseList] = React.useState([])
  const [activeDispatchesList, setActiveDispatchesList] = React.useState<
    ActiveDispatch[]
  >([])
  const [activeDispatch, setActiveDispatch] = React.useState<ActiveDispatch>({
    courier_id: '',
    courier_name: '',
    created_at: '',
    dispatch_id: 'new',
    dispatch_name: '',
    warehouse_id: null,
    warehouse_name: '',
  })
  const [selectedRider, setSelectedRider] = React.useState(null)
  const handleUpdate = () => {
    if (!selectedCompany) {
      showFailure('Please select a courier')
      return
    }
    if (!activeDispatch?.warehouse_id) {
      showFailure('Please select a warehouse')
      return
    }
    if (riderList.length && !selectedRider) {
      showFailure('Please select a rider ')
      return
    }
    if (selectedCompany?.courier_company === 'Pakistan Post') {
      const trackingNumbers = data.filter((item) => !item.tracking_number)
      if (trackingNumbers.length) {
        showFailure('Please enter tracking numbers for all orders')
        return
      }
    }
    if (
      (selectedCompany?.courier_company === 'Leopard' ||
        selectedCompany?.courier_company === 'Leopardv2') &&
      !CNSetting.shipmentType
    ) {
      showFailure('Please select a shipment type')
      return
    }
    if (CNSetting.isManualConsignment) {
      const trackingNumbers = data.filter((item) => !item.tracking_number)
      if (trackingNumbers.length) {
        showFailure('Please enter tracking numbers for all orders')
        return
      }
    }

    const { courier_id } = selectedCompany
    const rider_id = selectedRider
    const dispatch_id = activeDispatch?.dispatch_id
    const dispatch_name = activeDispatch?.dispatch_name
    const warehouse_id = activeDispatch?.warehouse_id
    const is_dispatch = CNSetting.isCreatedDispatch
    const is_manual_consignment = CNSetting.isManualConsignment
    const courier_name = selectedCompany?.courier_name
    const obj = {
      courier_id,
      rider_id,
      consignments: [],
      dispatch_id,
      dispatch_name,
      warehouse_id,
      is_dispatch,
      is_manual_consignment,
      courier_name,
    } as any
    if (CNSetting.serviceType !== false) {
      obj['order_type'] = CNSetting.serviceType
    } else if (CNSetting.serviceTypeRider !== false) {
      obj['order_type'] = CNSetting.serviceTypeRider
    } else if (CNSetting.courierServiceType !== false) {
      obj['order_type'] = CNSetting.courierServiceType
    }
    if (
      (selectedCompany?.courier_company === 'Leopard' ||
        selectedCompany?.courier_company === 'Leopardv2') &&
      CNSetting.shipmentType
    ) {
      obj['shipment_type'] = CNSetting.shipmentType
    }

    data.forEach((element: any) => {
      obj['consignments'].push({
        order_id: element['number'],
        status: element['status'],
        order_total: element['cod_amount'],
        tracking_id: element['tracking_number'],
      })
    })
    onCreateConsignment(obj)
  }
  React.useEffect(() => {
    if (!CNSetting.isManualConsignment) {
      const updatedData = data.map((item) => {
        return { ...item, tracking_number: '' }
      })
      setData(updatedData)
    }
  }, [CNSetting.isManualConsignment])
  React.useEffect(() => {
    if (isMustDispatch) {
      setCNSetting({
        ...CNSetting,
        isCreatedDispatch: true,
      })
    }
  }, [isMustDispatch])
  const getActiveDispatches = (selectedCompany) => {
    showPageLoader()
    get(`/courier/${selectedCompany?.courier_id}/dispatch`).subscribe(
      (res: any) => {
        hidePageLoader()
        if (res.response?.data) {
          if (res.response?.data.length > 0) {
            setActiveDispatchesList(res.response?.data)
            if (
              Number(selectedCompany?.company_id) !=
              COURIER_COMPANIES.one_logistics
            ) {
              const latestDispatchByDispatchId = res.response?.data?.reduce(
                (prev, current) =>
                  prev.dispatch_id > current.dispatch_id ? prev : current,
              )
              setActiveDispatch(latestDispatchByDispatchId)
            } else {
              getAllWarehouse(
                selectedCompany?.courier_id,
                selectedCompany?.courier_name,
              )
            }
          }
        }
      },
    )
  }
  // for auto select One Logistic Courier
  React.useEffect(() => {
    const logisticCourier = state?.couriers?.find(
      (item) => Number(item.company_id) == COURIER_COMPANIES.one_logistics,
    )
    if (logisticCourier) {
      setSelectedCompany(logisticCourier as any)
      setRiderList(
        logisticCourier && (logisticCourier as any).riders
          ? (logisticCourier as any).riders
          : [],
      )
    }
    setCNSetting({
      ...CNSetting,
      serviceType: false,
      serviceTypeRider: false,
      isCreatedDispatch: false,
      isManualConsignment: false,
      courierServiceType: false,
      shipmentType: '',
    })
  }, [state?.couriers])
  React.useEffect(() => {
    if (
      Number(selectedCompany?.company_id) == COURIER_COMPANIES.one_logistics
    ) {
      getAllWarehouse(selectedCompany?.courier_id, 'One Logistics')
    }
  }, [selectedCompany])
  const getAllWarehouse = (courier_id, company_name) => {
    showPageLoader()
    const urls =
      company_name === 'One Logistics'
        ? '/logistics/warehouses'
        : `/courier/${courier_id}/warehouses`
    get(urls).subscribe((res: any) => {
      hidePageLoader()
      if (res.response?.data) {
        setWarehouseList(res.response?.data)
        const defaultWarehouse = res.response?.data.find(
          (item) => item.is_serving,
        )
        if (defaultWarehouse) {
          setActiveDispatch({
            courier_id: '',
            courier_name: '',
            created_at: '',
            dispatch_id: 'new',
            dispatch_name: '',
            warehouse_id: defaultWarehouse.warehouse_id,
            warehouse_name: defaultWarehouse.warehouse_name,
          })
        }
      }
    })
  }
  React.useEffect(() => {
    if (selectedCompany?.courier_id && CNSetting.isCreatedDispatch) {
      getActiveDispatches(selectedCompany)
    }
  }, [selectedCompany, CNSetting.isCreatedDispatch])

  const columns = [
    {
      name: 'NO',
      selector: (row) => row.source_order_id,
    },
    {
      name: 'Name',
      selector: (row) =>
        row.customer
          ? row.customer
          : `${row.shipping?.first_name} ${row.shipping?.last_name}`,
    },
    {
      name: 'City',
      selector: (row) => (row.city ? row.city : row.shipping?.city),
    },
    {
      name: 'Total',
      selector: (row) => row.total,
    },
    {
      name: 'Payments',
      selector: (row) => row.advance_payment || 0,
    },
    {
      name: 'COD Amount',
      selector: (row) => row.cod_amount || row.total || 0,
    },
    {
      name: 'Weight',
      selector: (row) => row.weight || '--',
    },
    {
      name: 'Tracking #',
      selector: (row) => (
        <>
          {selectedCompany?.courier_type === 'manual' ||
          CNSetting.isManualConsignment ? (
            <DcInput
              isShowLabel={false}
              value={row.tracking_number}
              placeholder="Tracking #"
              name="tracking_number"
              onChange={(e) => {
                const newData = data.map((item) => {
                  if (item.number === row.number) {
                    item.tracking_number = e.target.value
                  }
                  return item
                })
                setData(newData)
              }}
            />
          ) : (
            row.tracking_number || '--'
          )}
        </>
      ),
    },
  ]
  const headerColor = {
    headCells: {
      style: {
        backgroundColor: '#ededed',
      },
    },
  }
  return (
    <PixelPageContainer
      maxHeight={'calc(100vh - 100px)'}
      padding={'5px'}
      backgroundColor={'#fff'}
    >
      <FiltersBar>
        {state?.couriers?.map((company: any) => (
          <FilterButton
            className={selectedCompany === company ? 'active' : ''}
            key={company.courier_id}
            onClick={() => {
              setSelectedCompany(company)
              setRiderList(company && company.riders ? company.riders : [])
              setCNSetting({
                ...CNSetting,
                serviceType: false,
                serviceTypeRider: false,
                isCreatedDispatch: false,
                isManualConsignment: false,
                courierServiceType: false,
                shipmentType: '',
              })
              if (
                Number(company?.company_id) !== COURIER_COMPANIES.one_logistics
              ) {
                getAllWarehouse(company?.courier_id, company?.courier_name)
              }
            }}
          >
            <img src={company.image_path} /> {company.courier_name}
          </FilterButton>
        ))}
      </FiltersBar>
      <SectionActions
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'flex-end',
          alignItems: isMobile ? 'flex-start' : 'flex-end',
          alignContent: 'flex-end',
          marginBottom: '10px',
          width: 'auto',
        }}
      >
        {selectedCompany?.courier_company === 'PostEx' && (
          <DcDiv width={isMobile ? '100%' : '230px'}>
            <DcSwitch
              name="serviceType"
              value={CNSetting.serviceType}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  serviceType: e.target.checked,
                })
              }}
              checked={CNSetting.serviceType}
              label={
                CNSetting.serviceType
                  ? 'Service Type : Yes'
                  : 'Service Type : No'
              }
            />
          </DcDiv>
        )}
        {selectedCompany?.courier_company === 'MNP' && (
          <DcDiv width="230px">
            <DcSwitch
              name="courierServiceType"
              value={CNSetting.courierServiceType}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  courierServiceType: e.target.checked,
                })
              }}
              checked={CNSetting.courierServiceType}
              label={
                CNSetting.courierServiceType
                  ? 'Service Type : Yes'
                  : 'Service Type : No'
              }
            />
          </DcDiv>
        )}
        {selectedCompany?.courier_company === 'Rider' && (
          <DcDiv width="230px">
            <DcSwitch
              name="serviceTypeRider"
              value={CNSetting.serviceTypeRider}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  serviceTypeRider: e.target.checked,
                })
              }}
              checked={CNSetting.serviceTypeRider}
              label={
                CNSetting.serviceTypeRider
                  ? 'Service Type : Yes'
                  : 'Service Type : No'
              }
            />
          </DcDiv>
        )}
        &nbsp; &nbsp;
        {Number(selectedCompany?.company_id) !==
          COURIER_COMPANIES.one_logistics && (
          <>
            <DcDiv width="230px">
              <DcSwitch
                name="isCreatedDispatch"
                disabled={
                  Number(selectedCompany?.company_id) ===
                  COURIER_COMPANIES.one_logistics
                }
                value={CNSetting.isCreatedDispatch}
                onChange={(e) => {
                  setCNSetting({
                    ...CNSetting,
                    isCreatedDispatch: e.target.checked,
                  })
                }}
                checked={CNSetting.isCreatedDispatch}
                label={
                  CNSetting.isCreatedDispatch
                    ? 'Create Dispatch : Yes'
                    : 'Create Dispatch : No'
                }
              />
            </DcDiv>
            &nbsp; &nbsp;
            {selectedCompany !== null && (
              <DcDiv width="275px">
                <DcSwitch
                  name="isManualConsignment"
                  disabled={
                    Number(selectedCompany?.company_id) ===
                      COURIER_COMPANIES.one_logistics ||
                    selectedCompany?.courier_type === 'manual'
                  }
                  value={CNSetting.isManualConsignment}
                  onChange={(e) => {
                    setCNSetting({
                      ...CNSetting,
                      isManualConsignment: e.target.checked,
                    })
                  }}
                  checked={
                    selectedCompany?.courier_type === 'manual'
                      ? true
                      : CNSetting.isManualConsignment
                  }
                  label={
                    CNSetting.isManualConsignment
                      ? 'Manual Consignment : Yes'
                      : 'Manual Consignment : No'
                  }
                />
              </DcDiv>
            )}
          </>
        )}
      </SectionActions>
      <DcFlexBox
        height="auto"
        justifyContent="flex-end"
        flexWrap="wrap"
        alignItems="flex-end"
        margin="0px 0px 20px 0px"
        gap="10px"
      >
        {CNSetting.serviceType && (
          <PixelDiv width={isMobile ? '100%' : '32%'}>
            <DcDropDown
              required
              customLabel=""
              value={CNSetting.serviceType.toString()}
              placeholder="Select Service Type"
              options={[
                {
                  value: 'Normal',
                  label: 'Normal',
                },
                {
                  value: 'Overland',
                  label: 'Overland',
                },
                {
                  value: 'Reversed',
                  label: 'Reversed',
                },
                {
                  value: 'Replacement',
                  label: 'Replacement',
                },
              ]}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  serviceType: e.target.value,
                })
              }}
            />
          </PixelDiv>
        )}
        {CNSetting.courierServiceType && (
          <PixelDiv width={isMobile ? '100%' : '32%'}>
            <DcDropDown
              required
              customLabel=""
              value={CNSetting.courierServiceType.toString()}
              placeholder="Select Service Type"
              options={[
                {
                  value: 'Overnight',
                  label: 'OverNight',
                },
                {
                  value: 'Second Day',
                  label: 'Second Day',
                },
              ]}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  courierServiceType: e.target.value,
                })
              }}
            />
          </PixelDiv>
        )}
        {CNSetting.serviceTypeRider && (
          <PixelDiv width={isMobile ? '100%' : '32%'}>
            <DcDropDown
              required
              customLabel=""
              value={CNSetting.serviceTypeRider.toString()}
              placeholder="Select Service Type"
              options={[
                {
                  value: '1',
                  label: 'Same Day',
                },
                {
                  value: '2',
                  label: '1-3 Day',
                },
                {
                  value: '5',
                  label: 'Detain',
                },
                {
                  value: '6',
                  label: 'Overland',
                },
                {
                  value: '7',
                  label: 'Overnight',
                },
                {
                  value: '8',
                  label: 'Next Day',
                },
              ]}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  serviceTypeRider: e.target.value,
                })
              }}
            />
          </PixelDiv>
        )}
        {(selectedCompany?.courier_company === 'Leopard' ||
          selectedCompany?.courier_company === 'Leopardv2') && (
          <PixelDiv width={isMobile ? '100%' : '32%'}>
            <DcDropDown
              required
              customLabel="Shipment Type"
              value={CNSetting.shipmentType}
              placeholder="Select Shipment Type"
              options={[
                {
                  value: '',
                  label: 'Select Shipment Type',
                },
                {
                  value: 'overnight',
                  label: 'Overnight',
                },
                {
                  value: 'overland',
                  label: 'Overland',
                },
                {
                  value: 'detain',
                  label: 'Detain',
                },
              ]}
              onChange={(e) => {
                setCNSetting({
                  ...CNSetting,
                  shipmentType: e.target.value,
                })
              }}
            />
          </PixelDiv>
        )}
        {CNSetting.isCreatedDispatch && (
          <>
            <PixelDiv width={isMobile ? '100%' : '32%'}>
              <DcDropDown
                customLabel=""
                required
                value={activeDispatch?.dispatch_id}
                placeholder="Select Dispatch"
                options={[
                  {
                    value: 'new',
                    label: 'New Dispatch',
                  },
                  ...activeDispatchesList.map((d) => {
                    return {
                      value: d['dispatch_id'],
                      label: `${d['courier_name']} - ${moment(
                        d['created_at'],
                      ).format('ll, h:mm:ss A')} - ${d['dispatch_id']}`,
                    }
                  }),
                ]}
                onChange={(e) => {
                  if (e.target.value !== 'new') {
                    const dispatch = activeDispatchesList.find(
                      (d) => d['dispatch_id'] === e.target.value,
                    )
                    if (dispatch) setActiveDispatch(dispatch)
                  } else {
                    setActiveDispatch({
                      courier_id: '',
                      courier_name: '',
                      created_at: '',
                      dispatch_id: 'new',
                      dispatch_name: '',
                      warehouse_id: 0,
                      warehouse_name: '',
                    })
                    if (
                      warehouseList?.length === 0 ||
                      Number(selectedCompany?.company_id) ===
                        COURIER_COMPANIES.one_logistics
                    ) {
                      getAllWarehouse(
                        selectedCompany?.courier_id,
                        'One Logistics',
                      )
                    }
                  }
                }}
              />
            </PixelDiv>
            {activeDispatch?.dispatch_id === 'new' && (
              <PixelDiv width={isMobile ? '100%' : '32%'}>
                <DcInput
                  name="dispatch_name"
                  required
                  value={activeDispatch?.dispatch_name}
                  placeholder="Dispatch Name"
                  onChange={(e) => {
                    setActiveDispatch({
                      ...activeDispatch,
                      dispatch_name: e.target.value,
                    })
                  }}
                />
              </PixelDiv>
            )}
          </>
        )}
        {Number(selectedCompany?.company_id) !==
          COURIER_COMPANIES.one_logistics && (
          <PixelDiv width={isMobile ? '100%' : '32%'}>
            <DcDropDown
              placeholder="Select Warehouse"
              customLabel=""
              required
              value={activeDispatch?.warehouse_id || ''}
              options={[
                {
                  value: '',
                  label: 'Select Warehouse',
                },

                ...warehouseList.map((w) => {
                  return {
                    value: w['warehouse_id'],
                    label: ` ${w['warehouse_name']} ${
                      !w['is_serving'] ? '(Not Mapped)' : ''
                    }`,
                    disabled: !w['is_serving'],
                  }
                }),
              ]}
              onChange={(e) => {
                setActiveDispatch({
                  ...activeDispatch,
                  warehouse_id: e.target.value,
                })
              }}
            />
          </PixelDiv>
        )}
        {riderList.length > 0 && (
          <PixelDiv width={isMobile ? '100%' : '30%'}>
            <DcDropDown
              customLabel=""
              placeholder="Select Rider"
              options={[
                {
                  rider_id: null,
                  rider_name: 'Select Rider',
                },
                ...riderList,
              ].map((rider) => {
                return {
                  label: rider.rider_name,
                  value: rider.rider_id || '',
                }
              })}
              value={selectedRider || ''}
              onChange={(e) => {
                setSelectedRider(e.target.value)
              }}
            />
          </PixelDiv>
        )}
        {Number(selectedCompany?.company_id) ===
          COURIER_COMPANIES.one_logistics && (
          <PixelFlexBox
            width="100%"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <PixelAlert
              style={{
                width: '50%',
              }}
              variant="primary"
            >
              <strong>Note:</strong>A dispatch will be automatically created if
              you do not have today dispatch with One Logistics. If a dispatch
              already exists, then add these orders to the existing one.
            </PixelAlert>
            <PixelDiv width={isMobile ? '100%' : '30%'}>
              <DcDropDown
                placeholder="Select Warehouse"
                customLabel=""
                required
                value={activeDispatch?.warehouse_id || ''}
                options={[
                  {
                    value: '',
                    label: 'Select Warehouse',
                  },
                  ...warehouseList.map((w) => {
                    return {
                      value: w['warehouse_id'],
                      label: w['warehouse_name'],
                    }
                  }),
                ]}
                onChange={(e) => {
                  setActiveDispatch({
                    ...activeDispatch,
                    warehouse_id: e.target.value,
                  })
                }}
              />
            </PixelDiv>
          </PixelFlexBox>
        )}

        <DcButton onClick={handleUpdate}>Create</DcButton>
      </DcFlexBox>
      {CNSetting.isCreatedDispatch && (
        <>
          {selectedCompany !== null && (
            <>
              {activeDispatch?.dispatch_id !== 'new' && (
                <DispatchDetailContainer>
                  <Left>
                    <CourierName>
                      <PixelTag className="primary">
                        {selectedCompany?.courier_company}
                      </PixelTag>
                    </CourierName>

                    <PageSummaryCard>
                      <CardItem> Dispatch ID: </CardItem>
                      <CODAmount>{activeDispatch?.dispatch_id}</CODAmount>
                    </PageSummaryCard>

                    <PageSummaryCard>
                      <CardItem> Dispatch Warehouse: </CardItem>
                      <CODAmount>{activeDispatch?.warehouse_name}</CODAmount>
                    </PageSummaryCard>
                    <PageSummaryCard>
                      <CardItem> Dispatch Name: </CardItem>
                      <CODAmount>{activeDispatch?.dispatch_name}</CODAmount>
                    </PageSummaryCard>
                  </Left>
                  <Right>
                    <PixelDate
                      className=""
                      value={activeDispatch?.created_at}
                      format={'pixelStandard'}
                    />
                  </Right>
                </DispatchDetailContainer>
              )}
            </>
          )}
        </>
      )}

      <TableContainer>
        <PixelTable
          customStyles={headerColor}
          pagination={false}
          columns={columns}
          data={data}
          fixedHeader
        />
      </TableContainer>
    </PixelPageContainer>
  )
}

const FiltersBar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  padding: 10px 0px;
  gap: 10px;
`

const FilterButton = styled.button`
  background-color: #f7f7f8;
  border: none;
  border-radius: 5px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #878c90;
  cursor: pointer;
  border-right: none;
  text-transform: capitalize;
  letter-spacing: 0.6px;

  &:hover,
  &.active {
    background-color: ${$DCprimaryColor};
    border-color: ${$DCprimaryColor};
    color: #fff;
  }
  &.disabled {
    background-color: #ccccd1;
    border-color: #ccccd1;
    color: #878c90;
    cursor: not-allowed;
    opacity: 0.8;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  }
`

const DispatchDetailContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: ${isMobile ? '98%' : '80%'};
  margin: 0 auto;
  justify-content: space-between;
  min-height: 150px;
  background: #ffffffd4;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
`

const Left = styled.div`
  padding-bottom: 10px;
`
const Right = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: ${isMobile ? '8px 0px 0px 8px' : '26px 20px 0px 0px'};
  padding-bottom: 10px;
`
const PageSummaryCard = styled.div`
  display: flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  align-items: ${isMobile ? 'flex-start' : 'flex-end'};
  margin: 0px 0px 0px 20px;
  gap: 5px;
`

const CODAmount = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: #344767;
`
const CourierName = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0px 10px 20px;
`

const CardItem = styled.span`
  color: #848aa2;
  font-size: 16px;
  margin-left: 5px;
  min-width: 175px;
`
const TableContainer = styled.div`
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  margin-bottom: 20px;
  border: 1px solid #e6e6e6;
  margin-top: 10px;
  > div {
    width: 100%;
  }
`
export default OrdersCreateBulkConsignments
